import { spectrum } from "@/lib/equalizer";

/* Bass-energy onset detector. Call `beatTick()` once per animation frame; returns a 0..1 pulse that spikes on a beat and decays. */
const hist = new Array(43).fill(0);
let hi = 0, pulse = 0, last = 0, lastFrame = 0;
export function beatTick(now) {
  if (now === lastFrame) return pulse;
  lastFrame = now;
  const s = spectrum(8);
  if (!s) { pulse *= 0.9; return pulse; }
  const e = (s[0] * s[0] + s[1] * s[1] + s[2] * s[2]) / 3;
  const avg = hist.reduce((a, b) => a + b, 0) / hist.length;
  hist[hi] = e; hi = (hi + 1) % hist.length;
  const onset = e > 0.08 && e > avg * 1.35 && now - last > 180;
  if (onset) { last = now; pulse = Math.min(1, Math.max(pulse, 0.6 + Math.min(0.4, (e - avg) * 2))); }
  else pulse *= 0.88;
  return pulse;
}
